import { EMPTY_CRITERIA_CONSGRP_ENTITY } from "domain/entity/Criteria/ConstraintGroupEntity";
import { EMPTY_POOL_EXCL_CRITERIA_ENTITY, EmptyPoolExclCriteriaEntity } from "domain/entity/EmptyPoolExclusion/EmptyPoolExclCriteriaEntity";
import { CompanyRepository } from "domain/repository/Company/CompanyRepo";
import { EmptyPoolExclCriteriaRepository } from "domain/repository/EmptyPoolExclCriteria/EmptyPoolExclCriteriaRepo";
import { OpsLineRepository } from "domain/repository/OpsLine/OpsLineRepo";
import { ParameterDetailRepository } from "domain/repository/parameter/ParameterDetailRepo";
import { TerminalRepository } from "domain/repository/Terminal/TerminalRepo";
import _ from "lodash";
import { EmpPoolChargeTypeDroOpts } from "presentation/constant/DropDownOptions/Charge/EmpPoolChargeTypeDroOpts";
import { CntrStatusDroOpts } from "presentation/constant/DropDownOptions/Company/CntrStatusDroOpts";
import { EmptyExclCriteriaModel } from "presentation/model/EmptyPoolExclusionCriteria/EmptyPoolExclusionCriteriaModel";
import { Dispatch, SetStateAction } from "react";
import { IFieldValue } from "veronica-ui-component/dist/component/core";
import BaseViewModel from "../BaseViewModel";

interface CriteriaVMProps extends BaseViewModel {
    dispatch: [
        Dispatch<SetStateAction<EmptyExclCriteriaModel>> | ((value: SetStateAction<EmptyExclCriteriaModel>) => void),
    ],
    emptyPoolExclRepo: EmptyPoolExclCriteriaRepository,
    opsLineRepo: OpsLineRepository,
    companyRepo: CompanyRepository,
    parameterDetailRepo: ParameterDetailRepository,
    terminalRepo: TerminalRepository,
}

export const EmptyPoolExclusionCriteriaVM = ({ dispatch, emptyPoolExclRepo, opsLineRepo, companyRepo, parameterDetailRepo, terminalRepo }: CriteriaVMProps) => {
    const [criteriaDispatch] = dispatch;

    const onRowDoubleClick = (entity: EmptyPoolExclCriteriaEntity) => {
        criteriaDispatch(prevState => {
            return {
                ...prevState,
                isShowCriteriaPanel: false,
                isShowDetail: true,
                currentSelectedRow: entity,
                masterState: {
                    ...prevState.masterState,
                    isTabularDataActive: false,
                    isAdd: false,
                    isRead: true,
                    isEditable: true,
                    isSaveClicked: false,
                    isSliderOpen: true,
                    allFormState: {}
                },
            }
        })
    }
    const onInitDefaultValue = async () => {
        criteriaDispatch(prevState => {
            const chargeType = prevState.masterState.editingCriteriaEntity.chargeType;
            const defChargeType = !chargeType ? prevState.dynamicOptions.chargeTypeDropdownOptions[0].value : chargeType;
            return {
                ...prevState,
                masterState: {
                    ...prevState.masterState,
                    editingCriteriaEntity: {
                        ...prevState.masterState.editingCriteriaEntity,
                        chargeType: defChargeType,
                    }
                }
            }
        })
    }
    const loadDropdownOption = async () => {
        await opsLineRepo.getOpsLineForCombobox().then(
            opsLines => {
                const opsLinesDropdownOptions = opsLines?.map((opsLineEntity) => ({
                    dropdownLabel: opsLineEntity.opsLine,
                    tagLabel: opsLineEntity.opsLine,
                    value: opsLineEntity.opsLine,
                })) ?? []

                criteriaDispatch(prevState => ({
                    ...prevState,
                    dynamicOptions: {
                        ...prevState.dynamicOptions,
                        opsLineDropdownOptions: opsLinesDropdownOptions
                    }
                }))
            }
        )

        await companyRepo.getAllCompanyForCombobox().then(
            companyCodeList => {
                const activeCompanyCode = companyCodeList?.filter((compCode) => {
                    return compCode.customerType === 'SL' && compCode.status === 'CONFIRMED' && compCode.activeInd === 'Y';
                });
                const opsLineCompanyDropdownOptions = activeCompanyCode?.map((companyEty) => ({
                    dropdownLabel: companyEty.companyCode,
                    tagLabel: companyEty.companyCode,
                    value: companyEty.companyCode,
                })) ?? []

                criteriaDispatch(prevState => ({
                    ...prevState,
                    dynamicOptions: {
                        ...prevState.dynamicOptions,
                        opsLineCompanyDropdownOptions: opsLineCompanyDropdownOptions
                    }
                }))
            }
        )

        await companyRepo.getAllCompanyForCombobox().then(
            companies => {
                let companyCodeDropdownOptions = companies?.filter(e => e.companyType !== 'MASTER' && e.companyType !== 'ALLIANCE').map((company) => ({
                    dropdownLabel: company.companyCode,
                    tagLabel: company.companyCode,
                    value: company.companyCode,
                })) ?? []
                companyCodeDropdownOptions = _.orderBy(companyCodeDropdownOptions, "dropdownLabel");

                criteriaDispatch(prevState => ({
                    ...prevState,
                    dynamicOptions: {
                        ...prevState.dynamicOptions,
                        chargeOnCompanyDropdownOptions: [
                            ...companyCodeDropdownOptions],
                    }
                }))
            }
        )

        await parameterDetailRepo.getAllParameterDtlsByParameterCode("CNTR_SIZE").then(
            cntrSizeList => {
                const sizeDropdownOption = cntrSizeList?.map((cntrSize) => ({
                    dropdownLabel: cntrSize.parameterDtlCode,
                    tagLabel: cntrSize.parameterDtlCode,
                    value: cntrSize.parameterDtlCode,
                })) ?? []

                criteriaDispatch(prevState => ({
                    ...prevState,
                    dynamicOptions: {
                        ...prevState.dynamicOptions,
                        cntrSizeDropdownOptions: sizeDropdownOption
                    }
                }))
            }
        )

        await parameterDetailRepo.getAllParameterDtlsByParameterCode("CNTR_TYPE").then(
            cntrTypeList => {
                const typeDropdownOption = cntrTypeList?.map((cntrType) => ({
                    dropdownLabel: cntrType.parameterDtlCode,
                    tagLabel: cntrType.parameterDtlCode,
                    value: cntrType.parameterDtlCode,
                })) ?? []

                criteriaDispatch(prevState => ({
                    ...prevState,
                    dynamicOptions: {
                        ...prevState.dynamicOptions,
                        cntrTypeDropdownOptions: typeDropdownOption
                    }
                }))
            }
        )

        await terminalRepo.getTerminalsForComboBox().then(
            terminalList => {
                const terminalDropdownOptions = terminalList?.map((terminal) => ({
                    dropdownLabel: terminal.terminalCode,
                    tagLabel: terminal.terminalCode,
                    value: terminal.terminalCode,
                })) ?? []

                criteriaDispatch(prevState => ({
                    ...prevState,
                    dynamicOptions: {
                        ...prevState.dynamicOptions,
                        operatingTmlDropdownOptions: terminalDropdownOptions
                    }
                }))
            }
        )

        await parameterDetailRepo.getAllParameterDtlsByParameterCode("LOCATION_TYPE").then(
            locationTypeList => {
                const locationTypeDropdownOption = locationTypeList?.map((locationType) => ({
                    dropdownLabel: locationType.parameterDtlCode,
                    tagLabel: locationType.parameterDtlCode,
                    value: locationType.parameterDtlCode,
                })) ?? []

                criteriaDispatch(prevState => ({
                    ...prevState,
                    dynamicOptions: {
                        ...prevState.dynamicOptions,
                        locationTypeDropdownOptions: locationTypeDropdownOption
                    }
                }))
            }
        )

        criteriaDispatch(prevState => ({
            ...prevState,
            dynamicOptions: {
                ...prevState.dynamicOptions,
                cntrStatusDropdownOptions: CntrStatusDroOpts().getDroOptsModel()
            }
        }))

        //AQCT / OICT /RSCT use
        criteriaDispatch(prevState => ({
            ...prevState,
            dynamicOptions: {
                ...prevState.dynamicOptions,
                chargeTypeDropdownOptions: EmpPoolChargeTypeDroOpts().getChargeTypeModel()
            }
        }))
    }

    const searchEmptyPoolExclusion = async () => {
        criteriaDispatch(prevState => {
            return {
                ...prevState,
                isRefreshInitData: false,
                selectedRows: [],
                criteriaEntityList: [],
                currentSelectedRow: { ...EMPTY_POOL_EXCL_CRITERIA_ENTITY },
            }
        })
        await emptyPoolExclRepo.getEmptyPoolExclusion().then((data) => {
            data = data.filter(data => data.exclusionType === 'EmptyPoolExclusionEntity')
            criteriaDispatch(prevState => {
                return {
                    ...prevState,
                    criteriaEntityList: data,
                    selectedRows: [],
                }
            })
        }).catch((error) => {
            return [];
        })

    }

    const onHeaderFieldChange = async (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;
        if (_.isArray(val)) {
            val = _.uniq(val?.map((item: any) => item.value || item.key));
        }

        criteriaDispatch(prevState => {

            return {
                ...prevState,
                masterState: {
                    ...prevState.masterState,
                    editingCriteriaEntity: {
                        ...prevState.masterState.editingCriteriaEntity,
                        [fieldKey]: val,
                    },
                    allFormState: {
                        [fieldKey]: '',
                    }
                }
            }
        })
    }

    const onSave = async (currentCriteriaEty: EmptyPoolExclCriteriaEntity, isAdd: boolean,vaidationError?:{[x:string]:string}) => {
        if (vaidationError && Object.keys(vaidationError).length > 0) {
            vaidationError = {
                ...vaidationError,
                checkFiled: "true"
            }
            criteriaDispatch(prevState => {
                return {
                    ...prevState,
                    masterState: {
                        ...prevState.masterState,
                        allFormState: {
                            ...vaidationError
                        }
                        
                    }
                }
            })
            return vaidationError;
        }
        let res = null;
        if (isAdd) {
            res = await emptyPoolExclRepo.createNewCriteria(currentCriteriaEty);
        } else {
            res = await emptyPoolExclRepo.updateCriteria(currentCriteriaEty);
        }

        if (res.success) {
            onCloseClick();
        } else {
            return res.data;
        }
    }

    const onCloseClick = () => {
        criteriaDispatch(prevState => {
            return {
                ...prevState,
                isShowDetail: false,
                isRefreshInitData: true,
                selectedRows: [],
                currentSelectedRow: { ...EMPTY_POOL_EXCL_CRITERIA_ENTITY },
                masterState: {
                    ...prevState.masterState,
                    isAdd: false,
                    isEditable: false,
                    isRead: true,
                    isTabularDataActive: true,
                    isSliderOpen: false,
                    editingCriteriaEntity: { ...EMPTY_POOL_EXCL_CRITERIA_ENTITY },
                    allFormState: {}
                },
            }
        });
    }

    const onSaveClicked = () => {
        criteriaDispatch(prevState => {
            return {
                ...prevState,
                masterState: {
                    ...prevState.masterState,
                    isSaveClicked: true,
                }
            }
        })
    }


    const onEdit = (currentTarCodeEty: EmptyPoolExclCriteriaEntity) => {
        criteriaDispatch(prevState => {
            return {
                ...prevState,
                masterState: {
                    ...prevState.masterState,
                    isAdd: false,
                    isRead: false,
                    isEditable: true,
                    editingCriteriaEntity: {
                        ...currentTarCodeEty,
                    }
                },
            }
        })
    }

    const onCheckboxChange = (checked: boolean, fieldName: string) => {
        criteriaDispatch(prevState => ({
            ...prevState,
            masterState: {
                ...prevState.masterState,
                editingCriteriaEntity: {
                    ...prevState.masterState.editingCriteriaEntity,
                    [fieldName]: checked ? "Y" : "N",
                }
            }
        }))
    }

    const onCancel = () => {
        criteriaDispatch(prevState => {
            return {
                ...prevState,
                masterState: {
                    ...prevState.masterState,
                    currentSelectItem: EMPTY_CRITERIA_CONSGRP_ENTITY,
                    isSliderOpen: false,
                }
            }
        })
    }

    const onComponentSaveClicked = () => {
        criteriaDispatch(prevState => {
            return {
                ...prevState,
                masterState: {
                    ...prevState.masterState,
                    isSaveClicked: true,
                }
            }
        })
    }

    const updateSelectedComponentRows = async (rows: any[]) => {
        criteriaDispatch(prevState => {
            return {
                ...prevState,
                selectedRows: rows,
            }
        })
    }

    const onAdd = () => {
        criteriaDispatch(prevState => {
            return {
                ...prevState,
                masterState: {
                    ...prevState.masterState,
                    editingCriteriaEntity: { ...EMPTY_POOL_EXCL_CRITERIA_ENTITY },
                    isAdd: true,
                    isSliderOpen: true,
                    isEditable: false,
                    isRead: false,
                    isSaveClicked: false,
                    allFormState: {}
                }
            }
        })
    }

    const onFieldChange = (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;

        if (_.isArray(val)) {
            val = _.uniq(val?.map((item: any) => item.value || item.key));
        }


        criteriaDispatch(prevState => {
            return {
                ...prevState,
                masterState: {
                    ...prevState.masterState,
                    editingCriteriaEntity: {
                        ...prevState.masterState.editingCriteriaEntity,
                        [fieldKey]: val,
                    },
                    allFormState: {
                        [fieldKey]: '',
                    }
                }
            }
        });
    }

    return {
        onHeaderFieldChange: onHeaderFieldChange,
        loadDropdownOption: loadDropdownOption,
        onRowDoubleClick: onRowDoubleClick,
        searchEmptyPoolExclusion: searchEmptyPoolExclusion,
        onSave: onSave,
        onCloseClick: onCloseClick,
        onSaveClicked: onSaveClicked,
        onEdit: onEdit,
        onCheckboxChange: onCheckboxChange,
        onCancel: onCancel,
        onAdd: onAdd,
        onComponentSaveClicked: onComponentSaveClicked,
        onFieldChange: onFieldChange,
        updateSelectedComponentRows: updateSelectedComponentRows,
        onInitDefaultValue: onInitDefaultValue
    }
}
